import { useState } from "react";
import ModalContato from "../ModalContato";
import { ContainerCard, CardStyle, images } from "../styles";
import { Card } from "antd";

export default function OndasPraia() {
  const { Meta } = Card;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({
    recepcaoTelefone: "",
    recepcaoEmail: "",
    conciergeWhatsApp: "",
    conciergeTelefone: "",
    conciergeEmail: "",
    wamLigacao: "",
    wamWhatsApp: "",
    wamEmail: "",
    wamPortal: "",
  });

  const showModal = (content: typeof modalContent) => {
    setModalContent(content); // Define o conteúdo personalizado do modal
    setIsModalOpen(true);
  };

  const handleFechar = () => {
    setIsModalOpen(false);
  };

  return (
    <ContainerCard>
      <Card
        hoverable
        style={CardStyle}
        cover={
          <a href="/empreendimentos/cronogramas/cronograma-ondas-praia-resort.pdf">
            <img
              alt="cronograma"
              src={images.calendario}
              style={{ width: "100%", height: "auto" }} // Ajuste o tamanho da imagem
            />
          </a>
        }
      >
        <Meta
          title="Cronograma"
          description="Última atualização em: 12/09/2024"
        />
      </Card>
      <Card
        hoverable
        style={CardStyle}
        cover={
          <a href="/empreendimentos/mapaApartamentos/mapa-apartamento-ondas-praias.pdf">
            <img
              alt="mapa-apartamentos"
              src={images.mapa}
              style={{ width: "100%", height: "auto" }} // Ajuste o tamanho da imagem
            />
          </a>
        }
      >
        <Meta
          title="Mapa de Apartamentos"
          description="Última atualização em: 12/09/2024"
        />
      </Card>
      <Card
        hoverable
        style={CardStyle}
        cover={
          <a href="/empreendimentos/alimentacao/alimentacao-ondas-praia.png">
            <img
              alt="example"
              src={images.alimentacao}
              style={{ width: "100%", height: "auto" }} // Ajuste o tamanho da imagem
            />
          </a>
        }
      >
        <Meta
          title="Alimentação"
          description="Última atualização em: 12/09/2024"
        />
      </Card>
      <Card
        hoverable
        style={CardStyle}
        cover={
          <a href="/empreendimentos/autorizacao/autorizacao-ondas-praia-resort.pdf">
            <img
              alt="autorizacao"
              src={images.autorizacao}
              style={{ width: "100%", height: "auto" }} // Ajuste o tamanho da imagem
            />
          </a>
        }
      >
        <Meta
          title="Autorização de Hospedagem"
          description="Última atualização em: 12/09/2024"
        />
      </Card>
      <Card
        hoverable
        style={CardStyle}
        cover={
          <a href="#">
            <img
              alt="contatos"
              src={images.contato}
              style={{ width: "100%", height: "auto" }} // Ajuste o tamanho da imagem
            />
          </a>
        }
        onClick={() =>
          showModal({
            recepcaoTelefone: "(71) 3511-6670",
            recepcaoEmail: "recepcao@ondasresort.com.br",
            conciergeWhatsApp: "(73) 9 9852 3409 (somente mensagem)",
            conciergeTelefone: "(71) 3511 6670 (somente ligação)",
            conciergeEmail: "concierge.ondas@wamhoteis.com.br",
            wamLigacao: "(62) 3142-2828",
            wamWhatsApp: "(62) 3252-6510",
            wamEmail: "atendimento@wam.group",
            wamPortal: "https://portal.wamgestao.com/login",
          })
        }
      >
        <Meta
          title="Contatos"
          description="Última atualização em: 12/09/2024"
        />
      </Card>
      <ModalContato
        isModalOpen={isModalOpen}
        handleFechar={handleFechar}
        content={modalContent} // Passando o conteúdo dinâmico
      />
    </ContainerCard>
  );
}
